import { render } from "./InvoicesManager.vue?vue&type=template&id=5c1d1928&scoped=true"
import script from "./InvoicesManager.vue?vue&type=script&lang=js"
export * from "./InvoicesManager.vue?vue&type=script&lang=js"

import "./InvoicesManager.vue?vue&type=style&index=0&id=5c1d1928&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c1d1928"]])

export default __exports__